import { FC, useState } from 'react';
import { DrawersContext, DrawerState } from './DrawersContext';

export const DrawersContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [eventName, setEventName] = useState<DrawerState | null>(null);

  const showDrawer = setEventName;
  const hideDrawer = () => setEventName(null);

  return (
    <DrawersContext.Provider
      value={{
        eventName,
        hideDrawer,
        showDrawer,
      }}
    >
      {children}
    </DrawersContext.Provider>
  );
};
